import React from 'react';
import styles from './HeaderDivider.module.css';

/** Thin vertical rule between header groups: `tall` on the left, `short` among the right-hand actions. */
const HeaderDivider = ({ size = 'tall', className = '' }) => (
    <span className={`${styles.divider} ${styles[size]} ${className}`.trim()} aria-hidden="true" />
);

export default HeaderDivider;
